import { create } from "zustand";

const ZustandValidationProponente = create((set, get) => ({
  buttonIsAtivoProponent: false,
  nomeProponente: "",
  rendaProponente: "",
  nascimentoProponente: "",
  proponentErro: false,

  nomeProponenteIsErro: false,
  nascimentoProponenteIsErro: false,
  rendaProponenteIsErro: false,

  setNomeProponenteIsErro: (value) => set({ nomeProponenteIsErro: value }),
  setNascimentoProponenteIsErro: (value) =>
    set({ nascimentoProponenteIsErro: value }),
  setRendaProponenteIsErro: (value) => set({ rendaProponenteIsErro: value }),
  setRendaProponente: (value) => set({ rendaProponente: value || ""  }),
  setButtonIsAtivoProponent: (value) => set({ buttonIsAtivoProponent: value }),
  setNomeProponente: (value) => set({ nomeProponente: value || "" }),
  setNascimentoProponente: (value) => set({ nascimentoProponente: value || "" }),
  setProponentErro: (value) => set({ proponentErro: value }),
}));

export default ZustandValidationProponente;
